import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  useToast,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import ProfileTab from "../components/mypage/ProfileTab";
import PasswordTab from "../components/mypage/PasswordTab";
import { useAuth } from "../context/AuthContext";
import { supabase } from "../lib/supabaseClient";

const MyPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [userProfile, setUserProfile] = useState(null);
  const toast = useToast();

  useEffect(() => {
    if (!user) {
      navigate("/login");
      return;
    }

    const fetchUserProfile = async () => {
      try {
        const { data, error } = await supabase
          .from("user")
          .select("*")
          .eq("email", user.email)
          .single();

        if (error) throw error;
        setUserProfile(data);
      } catch (error) {
        console.error("Error fetching user profile:", error);
        toast({
          title: "프로필 정보를 불러오는데 실패했습니다.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    };

    fetchUserProfile();
  }, [user, navigate]);

  if (!user) return null;

  return (
    <Container maxW="container.md" py={8}>
      <Tabs isFitted variant="enclosed">
        <TabList mb="1em">
          <Tab>프로필 수정</Tab>
          <Tab>비밀번호 변경</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <ProfileTab userProfile={userProfile} />
          </TabPanel>
          <TabPanel>
            <PasswordTab />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Container>
  );
};

export default MyPage;
